module.exports = __webpack_public_path__ + "static/notification-groups-add-06d46b2308af44271ed9623a0ed66cd3.png";